module.exports = __webpack_public_path__ + "75da3ecf6e528fe102437c796f728975.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/audios/2000_r_60.mp3
// module id = 425
// module chunks = 0